<!-- Takım Konfigürasyonu -->
<div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Takım Ayarları:
</div>

<!-- Takım Tipi Seçimi -->
<!-- <div style="margin-bottom: 0.5rem;">
    <label style="font-size:0.7rem;color:#fff;margin-bottom:3px;display:block;">Takım Tipi:</label>
    <div style="display: flex;gap: 2px;">
        <button class="ui mini button"
                [class.primary]="settings.toolConfig.toolType === 'ball'"
                (click)="toolTypeSec('ball')"
                style="flex:1;padding:0.4rem;font-size:0.65rem;">
            🔵 Ball
        </button>
        <button class="ui mini button"
                [class.primary]="settings.toolConfig.toolType === 'flat'"
                (click)="toolTypeSec('flat')"
                style="flex:1;padding:0.4rem;font-size:0.65rem;">
            ⬜ Flat
        </button>
        <button class="ui mini button"
                [class.primary]="settings.toolConfig.toolType === 'bullnose'"
                (click)="toolTypeSec('bullnose')"
                style="flex:1;padding:0.4rem;font-size:0.65rem;">
            🔶 Bull
        </button>
        <button class="ui mini button"
                [class.primary]="settings.toolConfig.toolType === 'chamfer'"
                (click)="toolTypeSec('chamfer')"
                style="flex:1;padding:0.4rem;font-size:0.65rem;">
            📐 Chamfer
        </button>
    </div>
</div> -->

<!-- Yüzey Seçim Durumu -->
<!-- <div *ngIf="yonSecimAktif"
     style="margin-bottom: 0.5rem;padding: 0.5rem;border-radius: 4px;font-size: 0.75rem;color: #333;">
    <strong>💡:</strong> Yüzeye tıkla
</div> -->

<!-- Seçili Yüzey Bilgisi -->
<!-- <div *ngIf="!yonSecimAktif && secilenFaceNormal"
     style="margin-bottom: 0.5rem;padding: 0.5rem;border-radius: 4px;font-size: 0.7rem;color: #333;">
    <div><strong>✓ Yüzey:</strong> ({{ secilenFaceNormal.x.toFixed(4) }}, {{ secilenFaceNormal.y.toFixed(4) }}, {{ secilenFaceNormal.z.toFixed(4) }})</div>
    <button (click)="resetYuzeySecimi()"
            class="ui mini button"
            style="width:100%;margin-top:3px;padding:4px 8px;font-size:11px;">
        Seçimi Sıfırla
    </button>
</div> -->

<!-- Yön Seç Butonu -->
<!-- <div style="margin-bottom: 0.5rem;">
    <button class="ui mini button fluid"
            [class.teal]="yonSecimAktif"
            (click)="yonSec()"
            [disabled]="yonSecimAktif"
            style="padding:0.4rem;">
        <i class="hand pointer icon"></i> Yüzey Seç
    </button>
</div> -->

<!-- Takım Yarıçapı -->
<!-- <div style="margin-bottom: 0.5rem;">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px;">
        <label style="font-size:0.7rem;color:#fff;">Takım Yarıçapı:</label>
        <span style="font-size:0.75rem;color:#4caf50;font-weight:600;">{{ settings.toolConfig.radius.toFixed(1) }}mm</span>
    </div>
    <input type="range"
           min="0.1"
           max="50"
           step="0.1"
           [value]="settings.toolConfig.radius"
           (input)="onToolRadiusChange($event)"
           style="width:100%;height:6px;background:linear-gradient(to right, #9c27b0, #f44336, #ffeb3b, #4caf50);border-radius:3px;">
    <div style="display:flex;justify-content:space-between;font-size:0.6rem;color:#666;margin-top:2px;">
        <span>0.1</span>
        <span>25</span>
        <span>50</span>
    </div>
</div> -->

<!-- Curvature Ölçeği (Kalibrasyon) -->
<div style="margin-bottom: 0.5rem;">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:3px;">
        <label style="font-size:0.7rem;color:#fff;">Kalibrasyon Ölçeği:</label>
        <span style="font-size:0.75rem;color:#fff;font-weight:600;">{{ curvatureScale.toFixed(2) }}</span>
    </div>
    <input type="range"
           min="0.1"
           max="100"
           step="0.1"
           [(ngModel)]="curvatureScale"
           (input)="onCurvatureScaleChange($event)"
           style="width:100%;height:6px;background:linear-gradient(to right, #2196f3, #00bcd4);border-radius:3px;">
    <div style="display:flex;justify-content:space-between;font-size:0.6rem;color:#fff;margin-top:2px;">
        <span>0.1</span>
        <span>50</span>
        <span>100</span>
    </div>
</div>

<!-- Radius Aralıkları -->
<div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Radius Aralıkları ({{ radiusRanges.length }}/10)
</div>

<!-- Mevcut Aralıklar Listesi -->
<div style="max-height: 200px;overflow-y: auto;margin-bottom: 0.5rem;border-radius: 4px;padding: 0.3rem;">
    <div *ngFor="let range of radiusRanges; let i = index"
         style="margin-bottom: 0.3rem;padding: 0.3rem;border-radius: 3px;">
        <div style="display:flex;gap:4px;align-items:center;margin-bottom:3px;">
            <input type="text"
                   [(ngModel)]="range.isim"
                   (change)="aralikDegisti()"
                   placeholder="İsim"
                   style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
            <input type="color"
                   [(ngModel)]="range.renk"
                   (change)="aralikDegisti()"
                   style="width:30px;height:20px;cursor:pointer;border:1px solid #fff;border-radius:2px;">
            <button class="ui mini icon button negative"
                    (click)="aralikSil(i)"
                    style="padding:4px 6px;font-size:0.6rem;">
                <i class="trash icon" style="margin:0;"></i>
            </button>
        </div>
        <div style="display:flex;gap:4px;align-items:center;">
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#fff;">Min:</label>
                <input type="number"
                       [(ngModel)]="range.min"
                       (change)="aralikDegisti()"
                       min="0"
                       max="999"
                       step="0.1"
                       style="width:100%;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
            </div>
            <div style="flex:1;">
                <label style="font-size:0.6rem;color:#fff;">Max:</label>
                <input type="number"
                       [(ngModel)]="range.max"
                       (change)="aralikDegisti()"
                       min="0"
                       max="999"
                       step="0.1"
                       style="width:100%;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
            </div>
            <div style="flex:1;text-align:center;font-size:0.65rem;color:#fff;">
                {{ (range.max - range.min).toFixed(1) }}°
            </div>
        </div>
    </div>
</div>

<!-- Yeni Aralık Ekle -->
<div style="margin-bottom: 0.5rem;padding: 0.3rem;border-radius: 4px;border:1px dashed rgba(33, 186, 69, 0.5);">
    <div style="font-size:0.7rem;margin-bottom:4px;color:#fff;">+ Yeni Aralık</div>
    <div style="display:flex;gap:4px;align-items:center;margin-bottom:3px;">
        <input type="text"
               [(ngModel)]="yeniAralik.isim"
               placeholder="Aralık İsmi"
               style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
        <input type="color"
               [(ngModel)]="yeniAralik.renk"
               style="width:30px;height:20px;cursor:pointer;border:1px solid #666;border-radius:2px;">
    </div>
    <div style="display:flex;gap:4px;align-items:center;margin-bottom:3px;">
        <input type="number"
               [(ngModel)]="yeniAralik.min"
               placeholder="Min"
               min="0"
               max="999"
               step="0.1"
               style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
        <span style="font-size:0.6rem;color:#fff;">-</span>
        <input type="number"
               [(ngModel)]="yeniAralik.max"
               placeholder="Max"
               min="0"
               max="999"
               step="0.1"
               style="flex:1;padding:2px 4px;font-size:0.65rem;background:rgba(0,0,0,0.3);color:#fff;border:1px solid #666;border-radius:2px;">
    </div>
    <button class="ui mini button green fluid"
            (click)="aralikEkle()"
            [disabled]="radiusRanges.length >= 10"
            style="padding:4px 8px;font-size:0.7rem;">
        <i class="plus icon"></i> Ekle
    </button>
</div>

<!-- Kontrol Butonları -->
<div class="ui horizontal divider header"
     style="margin-top: 0.5rem;margin-bottom:0.5rem;color: white;text-transform: unset;font-size:0.8rem;">
    Kontrol:
</div>

<div style="display: flex;justify-content: space-between;">
    <button class="ui icon mini green button"
            [disabled]="analizAktif"
            (click)="analiziBaslat()"
            style="flex:1;margin-right:5px;">
        <i class="play icon"></i>
        Başlat
    </button>
    <button class="ui icon mini red button"
            [disabled]="!analizAktif"
            (click)="analiziDurdur()"
            style="flex:1;margin-left:5px;">
        <i class="stop icon"></i>
        Durdur
    </button>
</div>

<!-- Durum -->
<div style="margin-top: 0.5rem;text-align: center;">
    <span style="font-size: 0.8rem;"
          [class.text-success]="analizAktif"
          [class.text-warning]="!analizAktif">
        <i [class]="analizAktif ? 'check circle icon' : 'pause circle icon'"></i>
        {{ analizAktif ? 'Analiz Aktif' : 'Analiz Pasif' }}
    </span>
</div>
